<script>
import {mapGetters, mapActions} from 'vuex'
import {ERROR_GENERIC, SUCCESS_EMAIL_SEND} from '../../utils/messages'
import {FAKE_ACTIVE, WS_URL} from '../../utils/config'
import Vue from 'vue'

export default {
  name: 'InviaEmailAction',
  methods: {
    ...mapGetters(['getSearch', 'getFlightFrom', 'getFlightsFrom', 'getFlightTo', 'getFlightsTo', 'getSpeseAccessorie', 'getPreventivo']),
    ...mapActions(['loadingStart', 'loadingEnd', 'loadActionPreventivo']),
    inviaEmail (email) {
      return FAKE_ACTIVE ? this.inviaEmailFake(email) : this.inviaEmailReal(email)
    },
    inviaEmailReal (email) {
      const preventivo = this.getPreventivo()
      const idPratica = preventivo.numeroPratica
      const url = preventivo.urlStampaFlexy
      const payload = {
        idPratica: idPratica,
        url: url,
        recipient: email
      }
      this.loadingStart()
      return new Promise((resolve, reject) => {
        Vue.axios.post(`${WS_URL}email`, payload, {withCredentials: true}).then(response => {
          const data = response.data
          if (!data.done && data.messages) {
            this.$toastr.error(ERROR_GENERIC)
            const error = {error: true, messages: data.messages}
            reject(error)
          } else {
            this.$toastr.success(SUCCESS_EMAIL_SEND)
            resolve(data)
          }
        }).catch(() => {
          this.$toastr.error(ERROR_GENERIC)
        }).finally(() => {
          this.loadingEnd()
        })
      })
    },
    inviaEmailFake (email) {
      return new Promise((resolve) => {
        this.$toastr.success('Email inviata a:', email)
        resolve('success')
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/actions/InviaMailAction.vue